import TaskList from '@/pages/task/TaskList.vue'
import ControlList from '@/pages/task/ControlList.vue'
import ObserverList from '@/pages/task/ObserverList.vue'
import TaskSingle from '@/pages/task/single/TaskSingle.vue'
import MainLayout from '@/layout/MainLayout.vue'
import TaskDashboard from '@/pages/task/Dashboard.vue'
import { RouterView } from 'vue-router'

export default [
  {
    path: '/tasks',
    name: 'tasks',
    component: MainLayout,
    meta: {
      title: 'Завдання',
      resource: 'tasks',
    },
    redirect: { name: 'task-dashboard' },
    children: [
      {
        path: '/task',
        name: 'task',
        component: RouterView,
        meta: {
          title: 'Завдання',
          resource: 'tasks',
        },
        children: [
          {
            path: ':id',
            name: 'single-task',
            component: TaskSingle,
            meta: {
              title: 'Завдання',
            },
          },
        ],
      },
      {
        path: 'dashboard',
        name: 'task-dashboard',
        component: TaskDashboard,
        meta: {
          title: 'Завдання — Дашборд',
        },
      },
      {
        path: 'incoming',
        name: 'incoming-tasks',
        component: TaskList,
        meta: {
          title: 'Вхідні завдання',
        },
      },
      {
        path: 'outgoing',
        name: 'outgoing-tasks',
        component: TaskList,
        meta: {
          title: 'Вихідні завдання',
        },
      },
      {
        path: 'control',
        name: 'control-tasks',
        component: ControlList,
        meta: {
          title: 'Контролюючі',
        },
      },
      {
        path: 'observer',
        name: 'observer-tasks',
        component: ObserverList,
        meta: {
          title: 'Наглядачі',
        },
      },
    ],
  },
]
